import { LoaderCircle, Sparkles } from 'lucide-react'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { AutosizeTextarea } from '@/components/ui/textarea'
import { KeywordHint } from './keyword-hint'
import type { UndecidedSchema } from './schemas'
import type { UseFormReturn } from 'react-hook-form'

type Props = {
  form: UseFormReturn<UndecidedSchema>
  onSubmit: (values: UndecidedSchema) => Promise<void> | void
  onGenerate: () => Promise<void> | void
  isGenerating: boolean
  isSubmitting: boolean
}

export function UndecidedForm({
  form,
  onSubmit,
  onGenerate,
  isGenerating,
  isSubmitting,
}: Props) {
  const generatedDescription = form.watch('description')

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="space-y-6"
      >
        <FormField
          control={form.control}
          name="keyword"
          render={({ field }) => (
            <FormItem>
              <FormLabel>依頼内容を1〜2文で入力してください。</FormLabel>
              <FormControl>
                <Input
                  placeholder="ミックスとマスタリング　3分程度　50トラック　ポップス"
                  {...field}
                />
              </FormControl>
              <FormMessage />
              <KeywordHint />
            </FormItem>
          )}
        />

        <button
          type="button"
          onClick={onGenerate}
          disabled={isGenerating || isSubmitting}
          className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-6 py-3 text-sm font-semibold text-foreground hover:bg-accent disabled:opacity-50"
        >
          {isGenerating ? (
            <LoaderCircle className="h-4 w-4 animate-spin" />
          ) : (
            <Sparkles className="h-4 w-4" />
          )}
          <span>AIで依頼作成</span>
        </button>

        {generatedDescription && (
          <div className="relative flex flex-col gap-6">
            <FormField
              control={form.control}
              name="title"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>ご相談内容</FormLabel>
                  <FormControl>
                    <Input
                      placeholder="ミックス・マスタリングを２曲お願いします"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="description"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>内容詳細</FormLabel>
                  <FormControl>
                    <AutosizeTextarea
                      className="min-h-50"
                      maxHeight={400}
                      minHeight={200}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            {isGenerating && (
              <div className="absolute inset-0 bg-background/70">
                <div className="flex justify-center items-center size-full!">
                  <LoaderCircle className="h-7 w-7 animate-spin" />
                </div>
              </div>
            )}
          </div>
        )}
      </form>
    </Form>
  )
}
